import { reactive, computed, watch } from "vue";
import { b as isClient } from "../utils/ssr-fd33979c.mjs";
import { u as useEvent } from "./useEvent-0856a587.mjs";
function useWindowSize() {
  const windowSizes = reactive({
    width: void 0,
    height: void 0
  });
  const setCurrentWindowSizes = () => {
    windowSizes.width = window == null ? void 0 : window.innerWidth;
    windowSizes.height = window == null ? void 0 : window.innerHeight;
  };
  const isMounted = computed(isClient);
  watch(isMounted, (newValue) => {
    if (!newValue) {
      return;
    }
    setCurrentWindowSizes();
  }, { immediate: true });
  useEvent("resize", setCurrentWindowSizes, true);
  return { windowSizes };
}
export {
  useWindowSize as u
};
//# sourceMappingURL=useWindowSize-08dee898.mjs.map
